import { useState, useEffect } from "react";
import { PaperPlaneRight, List, X } from "@phosphor-icons/react";
import { TELEGRAM_URL } from "@/App";

const links = [
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Why Me", href: "#trust" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
  { label: "Uploads", href: "#uploads" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 border-b ${
        scrolled
          ? "bg-background/70 backdrop-blur-xl border-border"
          : "bg-transparent border-transparent"
      }`}
    >
      <nav className="max-w-[1400px] mx-auto px-5 sm:px-8 h-16 sm:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="logo-link"
          className="font-display font-black tracking-tighter text-xl sm:text-2xl uppercase"
        >
          Craniel<span className="text-accent">.</span>
        </a>

        <div className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
              className="font-code text-xs uppercase tracking-[0.15em] text-muted-foreground hover:text-foreground transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            href={TELEGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-telegram-button"
            className="hidden sm:inline-flex items-center gap-2 bg-accent text-accent-foreground px-5 py-2.5 font-code text-xs uppercase tracking-[0.15em] font-medium hover:bg-blue-500 transition-colors duration-200 group"
          >
            Telegram
            <PaperPlaneRight
              size={15}
              weight="fill"
              className="group-hover:translate-x-1 transition-transform duration-200"
            />
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden text-foreground p-1"
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <List size={24} />}
          </button>
        </div>
      </nav>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-background/95 backdrop-blur-xl border-t border-border px-5 py-6 flex flex-col gap-5"
        >
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="font-code text-sm uppercase tracking-[0.15em] text-muted-foreground"
            >
              {l.label}
            </a>
          ))}
          <a
            href={TELEGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-telegram-button"
            className="inline-flex items-center gap-2 bg-accent text-accent-foreground px-5 py-3 font-code text-xs uppercase tracking-[0.15em] w-fit"
          >
            Contact on Telegram <PaperPlaneRight size={15} weight="fill" />
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
